import React from 'react';

const AppleLogo = (props) => {
	return (
		<div class="apple_logo mod_align_center">
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<g>
					<path fill="#FFFFFF" d="M20.67,15.61c0-0.96,0.52-2.65,2.33-3.72c-1.02-1.27-2.52-2.01-3.83-2.01c-2.25,0-2.71,0.9-3.81,0.9c-1.1,0-1.56-0.9-3.81-0.9c-2.25,0-5.05,2.16-5.05,5.45c0,6.36,4.02,9.68,5.34,9.68c1.37,0,2.21-0.82,3.52-0.82c1.31,0,2.15,0.82,3.52,0.82c0.97,0,3.41-1.81,4.62-5.31C21.12,18.51,20.67,16.56,20.67,15.61z"/>
					<path fill="#FFFFFF" d="M16.09,6.52C16.93,5.56,17.97,5.06,19.2,5c0.12,1.13-0.25,2.19-1.11,3.17c-0.9,1.04-1.95,1.52-3.16,1.43C14.81,8.51,15.2,7.48,16.09,6.52z"/>
				</g>
			</svg>
		</div>
	)
}

export default AppleLogo;